<template>
    <router-link 
      v-if="'acf' in project"
      :to="{ 
        name: 'details', 
        params: { 
          linkClick: true,
          projectSlug: project.slug,
          projectID: project.id
        }}">

      <div class="frame"></div>
      <span class="title" v-html="project.title.rendered"></span>
{{ project.acf.teaser_image.sizes }}
      <div class="transition-container">
        <img
          :data-left="transform.left"
          :data-top="transform.top"
          :data-scale="transform.scale"

          :style="'transform: translate(' + transform.left + '%, ' + transform.top + '%) scale('+ transform.scale +');'"
          :srcset="`
            ${project.acf.teaser_image.sizes.x_large} ${project.acf.teaser_image.sizes['x_large-width']}w,
            ${project.acf.teaser_image.sizes.large} ${project.acf.teaser_image.sizes['large-width']}w,
            ${project.acf.teaser_image.sizes.medium_large} ${project.acf.teaser_image.sizes['medium_large-width']}w,
            ${project.acf.teaser_image.sizes.medium} ${project.acf.teaser_image.sizes['medium-width']}w
          `"
          :sizes="`(max-width: 640px) 100vw, ${Math.round(width)}vw`"
          class="stream-image" 
          :src="project.acf.teaser_image.sizes.medium"
          @load="onImgLoad" alt="onimo STUDIOS Graz" />
      </div>
    </router-link>
</template>


<script>
  
  export default {
    name: 'gridItemContent',
    props: {
      index: Number,
      projectSlug: String,
      project: Object,
      width: Number,
    },
    data () {
      return {
        isLoaded: false,
        transform: {
          left: '',
          top: '',
          scale: ''
        }
      }
    },
    methods: {
      onImgLoad () {
        var $app = this.$root.$el;
        var $parent = this.$parent.$el;

        if( $app.classList.contains('ready') ){
          this.isLoaded = true;
          $parent.classList.remove('hidden');
        }else{
          setTimeout(() => {
            this.onImgLoad ();
          }, 100);
        }
      },


      resizeHandler(){
        if( this.project ){
          // if crop settings are set in WP backend & mobile
          if( window.innerWidth <= 640 && this.project.acf.crop_mobile ){
            this.transform.left = this.project.acf.crop_mobile.left;
            this.transform.top = this.project.acf.crop_mobile.top;
            this.transform.scale = this.project.acf.crop_mobile.scale;
          }
          // if crop settings are set in WP backend
          else{
            this.transform.left = this.project.acf.crop.left;
            this.transform.top = this.project.acf.crop.top;
            this.transform.scale = this.project.acf.crop.scale;
          }
        }
      }
    },
    created: function(){
      this.resizeHandler();
    },
    mounted: function () {
      window.addEventListener('resize', this.resizeHandler);
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  .transition-container{
    position: relative;
    transition: 0.15s;
    transition: 0.5s;
    transition-timing-function: easeInOut;
    width: 100%;
    height: 100%;
    overflow: hidden;

    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;

     background: black;
  }
  

  .clone-item{
    img,
    .transition-container{
      transition: 0s;
    }
  }

  img{
    position: relative;
    transition: 0.3s;
   
    // new
    position: absolute;
    z-index: 10;
    
    height: 100%;
    width: auto;
    left: 50%;
    overflow: hidden;
  }


  span.title{
    z-index: 15;
    color: white;
    position: absolute;
    left: 0%;
    bottom: 0%;
    text-transform: uppercase;
    background: black;
    padding: 0.5em 0.5em 0.4em;
    padding-left: calc(0.5em + 2px);
    transition-duration: 0.25s;
    transition-timing-function: easeInOut;
    // max-width: 80%;

  }

  .clone-item.hover-style,
  .stream-item:hover{
    .transition-container{

      img{
        opacity: 0.7;
      }
    }

    span.title{
      letter-spacing: calc( #{$letterSpacing} * 2 );
      font-size: 1rem;
      opacity: 1;
    }
  }


  .no-hover.clone-item{
    .transition-container{
      transform: scale(1);
    }
  }



  @keyframes fadeOut{
    from {
      opacity: 1; }
    to{
      opacity: 0; }
  }

  .clone-item{
    span.title{
      animation: fadeOut 0.5s ease-out;
      animation-fill-mode: forwards;
    }
  }
</style>